import { render, staticRenderFns } from "./mpesa-paybill.vue?vue&type=template&id=55971083"
import script from "./mpesa-paybill.vue?vue&type=script&lang=js"
export * from "./mpesa-paybill.vue?vue&type=script&lang=js"
import style0 from "./mpesa-paybill.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/mpesa-paybill/mpesa-paybill.vue
// module id = UFDg
// module chunks = 0